import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrequalificationPage = lazy(() => import('../pages/prequalification/page'));
const BusinessFundingPage = lazy(() => import('../pages/business-funding/page'));
const CitiesPage = lazy(() => import('../pages/cities/page'));
const CityHubPage = lazy(() => import('../pages/city-hub/page'));
const CityFundingPage = lazy(() => import('../pages/city-funding/page'));
const CityPrequalificationPage = lazy(() => import('../pages/city-prequalification/page'));
const ArticlePage = lazy(() => import('../pages/article/page'));
const WorkingCapitalPage = lazy(() => import('../pages/funding-working-capital/page'));
const LineOfCreditPage = lazy(() => import('../pages/funding-line-of-credit/page'));
const TermLoansPage = lazy(() => import('../pages/funding-term-loans/page'));
const EquipmentFinancingPage = lazy(() => import('../pages/funding-equipment-financing/page'));
const CommercialRealEstatePage = lazy(() => import('../pages/funding-commercial-real-estate/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const AffiliateDisclosurePage = lazy(() => import('../pages/affiliate-disclosure/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const AdminLayout = lazy(() => import('../pages/admin/components/AdminLayout'));
const AdminAuthGuard = lazy(() => import('../pages/admin/components/AdminAuthGuard'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/page'));
const AdminCitiesPage = lazy(() => import('../pages/admin/cities/page'));
const AdminArticlesPage = lazy(() => import('../pages/admin/articles/page'));
const AdminFunnelPage = lazy(() => import('../pages/admin/funnel/page'));
const AdminAffiliatesPage = lazy(() => import('../pages/admin/affiliates/page'));
const AdminAdsPage = lazy(() => import('../pages/admin/ads/page'));
const AdminAnalyticsPage = lazy(() => import('../pages/admin/analytics/page'));
const AdminSEOPage = lazy(() => import('../pages/admin/seo/page'));
const AdminFormsPage = lazy(() => import('../pages/admin/forms/page'));
const AdminLinksPage = lazy(() => import('../pages/admin/links/page'));

const ForSalePage = lazy(() => import('../pages/for-sale/page'));

const routes: RouteObject[] = [
  // Admin login (no auth guard)
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  // Admin panel (auth guarded + layout)
  {
    path: '/admin',
    element: (
      <AdminAuthGuard>
        <AdminLayout />
      </AdminAuthGuard>
    ),
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: 'cities', element: <AdminCitiesPage /> },
      { path: 'articles', element: <AdminArticlesPage /> },
      { path: 'funnel', element: <AdminFunnelPage /> },
      { path: 'affiliates', element: <AdminAffiliatesPage /> },
      { path: 'ads', element: <AdminAdsPage /> },
      { path: 'analytics', element: <AdminAnalyticsPage /> },
      { path: 'seo', element: <AdminSEOPage /> },
      { path: 'forms', element: <AdminFormsPage /> },
      { path: 'links', element: <AdminLinksPage /> },
    ],
  },
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/prequalification',
    element: <PrequalificationPage />,
  },
  {
    path: '/business-funding',
    element: <BusinessFundingPage />,
  },
  {
    path: '/business-funding/:fundingType',
    element: <BusinessFundingPage />,
  },
  {
    path: '/cities',
    element: <CitiesPage />,
  },
  {
    path: '/cities/:citySlug',
    element: <CityHubPage />,
  },
  {
    path: '/cities/:citySlug/prequalification',
    element: <CityPrequalificationPage />,
  },
  {
    path: '/cities/:citySlug/funding/:fundingType',
    element: <CityFundingPage />,
  },
  {
    path: '/cities/:citySlug/articles/:articleSlug',
    element: <ArticlePage />,
  },
  {
    path: '/funding/working-capital',
    element: <WorkingCapitalPage />,
  },
  {
    path: '/funding/line-of-credit',
    element: <LineOfCreditPage />,
  },
  {
    path: '/funding/term-loans',
    element: <TermLoansPage />,
  },
  {
    path: '/funding/equipment-financing',
    element: <EquipmentFinancingPage />,
  },
  {
    path: '/funding/commercial-real-estate',
    element: <CommercialRealEstatePage />,
  },
  {
    path: '/for-sale',
    element: <ForSalePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/affiliate-disclosure',
    element: <AffiliateDisclosurePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
